var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flows"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}],staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }